import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { useSettings } from "@/context/SettingsContext";
import { MessageSquareWarning, ArrowUpRight } from "lucide-react";

// Small "Report an issue / suggest a change" block shown on content pages.
// Copy is admin-editable via Admin → Page Titles (keys report.title / report.desc / report.cta).
export default function ReportIssue({ area = "", className = "" }) {
  const { pick } = useLang();
  const { copy } = useSettings();
  const title = copy("report.title", "Spot an error or have a suggestion?", "कोई त्रुटि दिखी या सुझाव है?");
  const desc = copy("report.desc", "Help us keep this accurate — report a mistake or suggest content for this page.", "इसे सटीक बनाए रखने में सहायता करें — त्रुटि बताएँ या सामग्री सुझाएँ।");
  const cta = copy("report.cta", "Report an issue / Suggest a change", "समस्या बताएँ / सुझाव दें");
  const href = `/feedback?type=suggestion${area ? `&area=${encodeURIComponent(area)}` : ""}`;

  return (
    <div data-testid="report-issue" className={`mt-10 flex flex-col gap-3 border border-line bg-[var(--parchment)] p-5 sm:flex-row sm:items-center sm:justify-between ${className}`}>
      <div className="flex items-start gap-3">
        <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-[var(--gold-muted)] text-gold">
          <MessageSquareWarning className="h-4 w-4" />
        </span>
        <div>
          <p className="font-serif-latin text-base text-ink">{pick(title.hi, title.en)}</p>
          <p className="mt-0.5 text-sm text-ink-2">{pick(desc.hi, desc.en)}</p>
        </div>
      </div>
      <Link to={href} data-testid="report-issue-cta"
        className="inline-flex shrink-0 items-center gap-1.5 self-start border border-saffron px-4 py-2 text-sm font-medium text-saffron transition-colors hover:bg-[var(--saffron)] hover:text-white sm:self-auto">
        {pick(cta.hi, cta.en)} <ArrowUpRight className="h-3.5 w-3.5" />
      </Link>
    </div>
  );
}
